import React, { useState, createContext } from 'react'
import styled, { css } from 'styled-components'
import { ReactComponent as Expand } from '@sketch/icons/rectangle-diagonal-arrow-up-left-17'

const ExpandIcon = styled(Expand)`
  flex: none;
  height: 17px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  position: absolute;
  right: 16px;
  top: 8px;
  cursor: pointer;
`

const HoverContainer = styled.div<{
  visible?: boolean
}>(
  ({ theme, visible }) => css`
    min-width: calc(100% + 24px);
    min-height: 31px;
    position: relative;
    display: flex;
    align-items: center;
    background-color: ${visible ? theme.colors.state.hover : undefined};
    border-radius: ${theme.radii.large};

    margin-bottom: 4px;
    margin-left: -12px;
    padding-left: 12px;
    margin-right: -12px;
    padding-right: 12px;

    &:hover {
      background-color: ${theme.colors.state.hover};
    }

    &:active {
      background-color: ${theme.colors.background.tertiary.B};
    }
  `
)

export const HoverFillColorContext = createContext<{
  isPopoverOpen: boolean
  setPopoverOpen: (isPopoverOpen: boolean) => void
}>({
  isPopoverOpen: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setPopoverOpen: (_isPopoverOpen: boolean) => {},
})

export const HoverFillColor: React.FC<{
  visible?: boolean
  canExpand?: boolean
}> = ({ children, canExpand }) => {
  const [isPopoverOpen, setPopoverOpen] = useState(false)

  return (
    <HoverFillColorContext.Provider value={{ isPopoverOpen, setPopoverOpen }}>
      <HoverContainer data-testid="hoverable" visible={isPopoverOpen}>
        {children}
        {canExpand ? <ExpandIcon data-testid="expand-icon" /> : null}
      </HoverContainer>
    </HoverFillColorContext.Provider>
  )
}
